import { createTypedUseAuth } from '@codezo/auth';
import { AuthRoleEnum } from '@codezo/graphql';

export type VetterUserType = {
	id: string;
	email: string;
	role: AuthRoleEnum;
	vetterUser: {
		vetterEntityId: string;
		firstName: string;
		lastName: string;
	} | null;
};

export const useAuth = createTypedUseAuth<VetterUserType>();
